import React from 'react';
import { Skeleton } from '@material-ui/lab';
import { Paper, Table, TableBody, TableHead, TableCell, TableRow } from '@material-ui/core';
import { useTableStyle } from '../../../utils/materialStyles';
const STableLoader = ({ count, height,width,size }) => {
    const classes = useTableStyle();
    return (
        <Paper>
            <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                stickyHeader={true}
                size='medium'
            >
                <TableHead className="mui-table">
                    <TableRow>
                        {Array(count).fill(0).map((item, index) =>
                            <TableCell key={index} align="left">
                                <Skeleton variant="rect" animation='wave' height={24} width={width} />
                            </TableCell>
                        )}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Array(size ? size : 10).fill(0).map((row, index) =>
                        <TableRow key={index}>
                            {Array(count).fill(0).map((item, index) =>
                                <TableCell key={index} align="left">
                                    <Skeleton variant="rect" animation='wave' height={36} width={width}/>
                                </TableCell>
                            )}
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </Paper>
    )
}
export default STableLoader;
